import { useEffect, useRef, useState } from 'react';
import { useBranch } from '../../context/BranchContext';

/**
 * Selector de sucursal de la barra de navegacion. No pinta nada si el
 * interruptor de sucursales esta apagado (web publica actual).
 * `variant="list"` es la version del menu movil: botones a lo ancho.
 */
export default function BranchPicker({ variant = 'dropdown' }: { variant?: 'dropdown' | 'list' }) {
  const { enabled, branches, branch, setBranch } = useBranch();
  const [open, setOpen] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!open) return;
    const close = (e: MouseEvent | KeyboardEvent) => {
      if (e instanceof KeyboardEvent ? e.key === 'Escape' : !ref.current?.contains(e.target as Node)) setOpen(false);
    };
    document.addEventListener('mousedown', close);
    document.addEventListener('keydown', close);
    return () => {
      document.removeEventListener('mousedown', close);
      document.removeEventListener('keydown', close);
    };
  }, [open]);

  if (!enabled) return null;

  if (variant === 'list') {
    return (
      <div className="sp-branch-list" role="radiogroup" aria-label="Sucursal">
        <p>Sucursal</p>
        {branches.map((b) => (
          <button
            key={b.key}
            type="button"
            role="radio"
            aria-checked={b.key === branch.key}
            className={b.key === branch.key ? 'is-active' : ''}
            onClick={() => setBranch(b.key)}
          >
            <i className="ri-store-2-line" /> {b.city}
          </button>
        ))}
      </div>
    );
  }

  return (
    <div className="sp-branch" ref={ref}>
      <button
        type="button"
        className="sp-branch-toggle"
        aria-haspopup="listbox"
        aria-expanded={open}
        title="Elegir sucursal"
        onClick={() => setOpen((o) => !o)}
      >
        <i className="ri-store-2-line" />
        <span>{branch.city}</span>
        <i className="ri-arrow-down-s-line" />
      </button>
      {open && (
        <ul className="sp-branch-menu" role="listbox" aria-label="Sucursal">
          {branches.map((b) => (
            <li key={b.key}>
              <button
                type="button"
                role="option"
                aria-selected={b.key === branch.key}
                className={b.key === branch.key ? 'is-active' : ''}
                onClick={() => {
                  setBranch(b.key);
                  setOpen(false);
                }}
              >
                <strong>{b.city}</strong>
                <span>{b.address}</span>
              </button>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
